<template>
	<router-link :to="to" class="person">
		<div class="image">
			<img :src="image ? image : '/assets/Icons/user.png'" />
		</div>
		<div class="name">{{ name }}</div>
		<div class="level">{{ rank }}</div>
	</router-link>
</template>

<script>
export default {
	props: {
		name: {
			default: '-',
			type: String,
		},
		rank: {
			default: '-',
			type: String,
		},
		image: {
			default: '/assets/Icons/user.png',
			type: String,
		},
		to: {
			default: () => ({}),
			type: Object,
		},
	},
};
</script>

<style scoped>
.person {
	padding: 0 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 200px;
}

.image {
	width: 100%;
	height: 50%;
	padding: 10px 30px;
}
.image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 50%;
}
.name {
	font-size: 20px;
	line-height: 35px;
	font-family: changeBold;
	text-align: center;
}
.level {
	font-size: 16px;
	font-family: changeMedium;
	text-align: center;
	color: grey;
}
@media only screen and (max-width: 786px) {
	.person {
		padding: 0 10px;
		width: 160px;
	}
	.name {
		font-size: 16px;
	}
	.level {
		font-size: 14px;
	}
}
</style>
